import { formatLocalDatetime } from 'syft-acp-util/time'

import type { BlockActor, BlockLevel } from 'syft-acp-core/store/worker-blocks/types'

/**
 * An employer-level block hides the worker at every venue, so it keeps the
 * "Employer-level" tag the employer Blocks tab uses when the backend unions it
 * into a venue-filtered list. That distinction is the incident blind spot the
 * Blocks tabs exist to close, so both tabs name it the same way.
 */
const levelLabels: Record<BlockLevel, string> = {
  employer: 'Employer-level',
  venue: 'Venue',
}

/** Returns null for an unknown level so the table renders its own empty cell. */
export const levelLabel = (level?: BlockLevel | null): string | null => (level && levelLabels[level]) || null

// Returns null when there is no actor so the cell renders the uikit's standard
// empty-value dash, rather than a second dash character of our own.
export const blockedByLabel = (row: {
  blocked_by?: BlockActor | null
  impersonating_user?: BlockActor | null
}): string | null => {
  const blockedBy = row.blocked_by?.name || (row.blocked_by?.id ? `User #${row.blocked_by.id}` : null)
  if (!blockedBy) return null

  const impersonator = row.impersonating_user?.name

  return impersonator ? `${blockedBy} (as ${impersonator})` : blockedBy
}

export const expiresLabel = (row: { expires_at?: string | null }): string => {
  if (!row.expires_at) {
    return 'Permanent'
  }

  return formatLocalDatetime(row.expires_at).formatted
}
